import type { MouseEvent } from 'react';
import { useEffect, useState } from 'react';

type TooltipState = {
  left: number;
  text: string;
  top: number;
} | null;

export const useTimezoneTooltip = () => {
  const [tooltip, setTooltip] = useState<TooltipState>(null);

  useEffect(() => {
    if (!tooltip) {
      return undefined;
    }

    const hideTooltip = () => {
      setTooltip(null);
    };

    window.addEventListener('scroll', hideTooltip, true);
    window.addEventListener('resize', hideTooltip);

    return () => {
      window.removeEventListener('scroll', hideTooltip, true);
      window.removeEventListener('resize', hideTooltip);
    };
  }, [tooltip]);

  const hideTooltip = () => {
    setTooltip(null);
  };

  const showTooltip = (event: MouseEvent<HTMLDivElement>, timeZone: string) => {
    const bounds = event.currentTarget.getBoundingClientRect();

    setTooltip({
      left: bounds.left + bounds.width / 2,
      text: timeZone,
      top: bounds.top,
    });
  };

  return {
    hideTooltip,
    showTooltip,
    tooltip,
  };
};
